import { PropsWithChildren } from "react";

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { ClientInformation, compatibility, standardCompatibility } from '@lcms/supported-browsers'
import { NotCompatible } from ".";

export interface CompatibilityCheckProps {
    Fallback?: React.ReactNode;
    clientCompatibility?: (client: ClientInformation) => boolean;
}
export function CompatibilityCheck({ children, Fallback, clientCompatibility: clientCompatibility }: PropsWithChildren<CompatibilityCheckProps>) {
    return <>{compatibility(clientCompatibility || standardCompatibility) ? children : (Fallback || <NotCompatible />)}</>
}